
import { schema } from "./types";
import { IAutomationAppComponent } from "../../../types";
import { OverviewPanel } from "./OverviewPanel";
import { TimeRange } from "../PortfolioEnergyChart/types";
import { OperatorPanel } from "./OperatorPanel";


export const App : IAutomationAppComponent = {
    schema: schema,
    supportsProcessPanel: false,
    Icon: undefined,
    OverviewPanel: OverviewPanel,
    OperatorPanel: OperatorPanel,
    createConfig:  {
        group: 'ReportsAndStatistics',
        name: "See when energy is consumed (Portfolio wide)",
        description: "Portfolio Energy consumption heatmap",
        panel: OverviewPanel,
        defaultState: { timeRange: TimeRange.YearToDate },
        defaultProperties: [ ]
    },
}